import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BulkActionsBar = ({ selectedCount, onAssignGroup, onRequestDocuments, onSendMessage, onExport, onClearSelection, currentLanguage = 'fr' }) => {
  const labels = {
    fr: {
      selected: 'sélectionné(s)',
      assignGroup: 'Assigner au groupe',
      requestDocuments: 'Demander documents',
      sendMessage: 'Envoyer message',
      export: 'Exporter',
      clearSelection: 'Désélectionner'
    },
    ar: {
      selected: 'محدد',
      assignGroup: 'تعيين للمجموعة',
      requestDocuments: 'طلب الوثائق',
      sendMessage: 'إرسال رسالة',
      export: 'تصدير',
      clearSelection: 'إلغاء التحديد'
    }
  };

  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 w-full max-w-4xl px-4">
      <div className="bg-primary text-primary-foreground rounded-lg shadow-warm-lg p-4 flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2">
          <Icon name="CheckSquare" size={20} />
          <span className="font-medium">
            {selectedCount} {labels?.[currentLanguage]?.selected}
          </span>
        </div>

        <div className="flex-1" />

        <div className="flex flex-wrap items-center gap-2">
          <Button
            variant="secondary"
            size="sm"
            iconName="Users"
            iconPosition="left"
            onClick={onAssignGroup}
          >
            {labels?.[currentLanguage]?.assignGroup}
          </Button>

          <Button
            variant="secondary"
            size="sm"
            iconName="FileText"
            iconPosition="left"
            onClick={onRequestDocuments}
          >
            {labels?.[currentLanguage]?.requestDocuments}
          </Button>

          <Button
            variant="secondary"
            size="sm"
            iconName="MessageSquare"
            iconPosition="left"
            onClick={onSendMessage}
          >
            {labels?.[currentLanguage]?.sendMessage}
          </Button>

          <Button
            variant="secondary"
            size="sm"
            iconName="Download"
            iconPosition="left"
            onClick={onExport}
          >
            {labels?.[currentLanguage]?.export}
          </Button>

          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={onClearSelection}
          />
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;